import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/buttons/Button';
import './account-limit-reached.css';

export const AccountLimitReached = () => {
    const navigate = useNavigate();

    return (
        <div className="account-limit">
            <div className="account-limit__card">
                <p className="account-limit__eyebrow">Sesión en uso</p>
                <div className="account-limit__seats" aria-hidden="true">
                    <span className="account-limit__seat is-taken">
                        <span className="account-limit__dot" />
                    </span>
                    <span className="account-limit__seat is-blocked">
                        <span className="account-limit__slash" />
                    </span>
                </div>
                <h1 className="account-limit__title">
                    El límite de uso de la cuenta se ha alcanzado
                </h1>
                <p className="account-limit__body">
                    Esta cuenta ya está dentro de la clase en otro dispositivo.
                    Cierra esa sesión para entrar aquí.
                </p>
                <Button
                    variant="gradient"
                    onClick={() => navigate('/cursos', { replace: true })}
                >
                    Volver a cursos
                </Button>
            </div>
        </div>
    );
};
